import { Observable, SchedulerLike } from "rxjs";
import { categories } from "./categories";

export type MarbleInput = {
  t: number; // time: 0 ~ 100
  c: number | string; // 显示字符
};

export type MarbleInputArray = MarbleInput[];
// export type MultiMarbleInputArray = MarbleInputArray[];

export type TimelineInput = (MarbleInput | number)[]; // last of array 如果是 number = EndMarkerTime
export type TimelineInputArray = TimelineInput[];

export type Props = { minTime: number; maxTime: number; isTall?: boolean };

export type Marble = {
  marbleID: number;
  time: number; // time: 0 ~ 100
  content: string | number; // 显示字符
};

export type EndMarker = Pick<Marble, "time">;
export type ErrorMarker = Pick<Marble, "time">;

export type Timeline = {
  timelineID: number;
  marbles: Marble[];
  end: EndMarker;
  error?: ErrorMarker;
  interactive: boolean;
};

export type Example = {
  label: string;
  inputs: TimelineInputArray;
  apply: (
    inputs: Observable<Marble>[],
    scheduler: SchedulerLike
  ) => Observable<any>;
};

export type Examples = {
  [index: string]: Example;
};

export const examples: Examples = Object.values<Examples>(categories).reduce(
  (acc, o) => Object.assign(acc, o),
  {}
);

export { categories };
